export const LOCAL_STORAGE_VARIABLES = {
  TOKEN: "token",
  ONBOARDED: "onboarded",
  ACTIVE_EXCHANGE: "activeExchange",
};
